import formatDate  from './format-date'

const filters  = {
    formatDate: formatDate
}

export default filters



// WEBPACK FOOTER //
// ./src/filters/main.js